import { render, staticRenderFns } from "./DescriptionsList.vue?vue&type=template&id=0c687af0&"
import script from "./DescriptionsList.vue?vue&type=script&lang=js&"
export * from "./DescriptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports